
import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import DocumentAnalysisContext from '../../../contexts/DocumentAnalysisContext'
import AuthContext from '../../../contexts/AuthContext'
import { TestPrice } from '../aitest/TestPrice'
import { Description } from '../aitest/Description'
import { Context } from '../aitest/Context'
import { Subtopics } from '../aitest/Subtopics'
import { ConnectedAccountDialog } from '../purchasetest/ConnectedAccountDialog'
import { Questions } from "../aitest/Questions"
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Account } from '../aitest/Account'
import { DialogTestLanguage } from './DialogTestLanguage';
import { PushButton } from '../pushbutton/PushButton'
//import FileUploader from '../FileUploader/FileUploader'
import { useState, useEffect } from "react";
import { ConfirmDialog } from '../alertdialog/ConfirmDialog';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { DialogTestArea } from './DialogTestArea';
import { TestLanguage } from './TestLanguage'
import { PageTitle } from './PageTitle'

import "./aitest.css"

export const CreateTest = () => {
  const [openConfirmDialog, handleConfirmDisplay] = useState(false);
  const [dialogtext, setDialogText] = useState('');

  const {
    changeLanguage,
    isMe,
  } = React.useContext(StatusContext);

  const {
    onChangeContext,
    topic,
    setCreatorName,
    creatorname,
    isLoading,
    testprice,
    description,
    onChangeDescription,
    showaccount,
    onMyAccount,
    accountbalance,
    descriptionRef,
    onNewQuestions,
    promptsandresponses,
    area,
    subarea,
    setShowTestAreaDlg,
  } = React.useContext(AITestContext);

  const {
    getFileDetails,
    attachedFiles,
    removeFile,
  } = React.useContext(DocumentAnalysisContext);

  const {
    checkCurrentUser,
  } = React.useContext(AuthContext)

   useEffect(() => {
      console.log("Create test useEffect")
      if (checkCurrentUser())
        getFileDetails();
    
    }, [checkCurrentUser, getFileDetails])   

const openConfirmDialogBox = () => {
    handleConfirmDisplay(true);
}

const closeConfirmDialogBox = () => {
    handleConfirmDisplay(false);
};

const confirmYes = () => {
    closeConfirmDialogBox()
}

const onShowAreas = () => {
    setShowTestAreaDlg(true)
}



const handleonNewQuestions = () => {

  if (promptsandresponses.length > 60)
  {
    setDialogText(changeLanguage('aitest', 'questionslimit'))
    openConfirmDialogBox()
  }
  else 
    onNewQuestions(-1)
}

  return (
    <div>
    
   
       <div className='moveRight' >
        <PageTitle title = {changeLanguage('aitest', 'createtesttitle')}/>
      
        <TestLanguage />
       
        <div className="aitestAuthorSpace">
        <label className='aitestAuthorLabel'>{changeLanguage('aitest', 'creatorname')}: </label>
        <input type="text" maxLength="40" className="aitestAuthor"
          value={creatorname} onChange={(e) => setCreatorName(e.target.value)} />
      </div>
   

      {
        isMe() &&
        <>
        <br></br>
          <div style = {{marginTop:'20px', marginBottom:'10px'}}> 
        
            {changeLanguage('aitest', 'createaccounttext')}
          </div>
   

          <div className="accountButton" onClick={() => { onMyAccount() }}>
            {
              (showaccount) ?
                <ExpandLess className="aitestIcon" />
                :
                <ExpandMore className="aitestIcon" />
            }
            {changeLanguage('aitest', 'activity')}
          </div>
          <br></br>

          {
            (showaccount) &&
            <Account balance={accountbalance} />
          }

          <TestPrice price={testprice} />
          <br></br>
      </>
      }
  
      <div style = {{marginTop:'10px', marginBottom:'10px'}}>
          <AutoAwesomeMotionIcon className="languageIcon" onClick={onShowAreas}/>
          <label className='navbarFonts' style={{paddingLeft: '5px', fontWeight:'700'}}>{changeLanguage('aitest','areas')}{<span style={{fontSize:'16px'}}>{area}</span>}{area?.length ? ' - ' : ''}{subarea}</label>
      </div>
      <br></br>
      <div className = 'descriptionStyle'>
        <Description title={changeLanguage('aitest', 'description')} description={description} placeholder={changeLanguage('aitest', 'descriptionprompt')} onChange={onChangeDescription} />
      </div>
      <br></br>

        <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', alignItems: 'flex-start' }}>
         
          {

            <div className = 'descriptionStyle' >
              <Context
                topic={topic}
                disabled={isLoading}
                onChange={event => onChangeContext(event)}
                attachedFiles={attachedFiles} 
                deleteFile={removeFile}/>

            {/*
              isMe() && 
              <>
                <br></br>
                <FileUploader style={{ cursor: 'pointer'}}/>
                <br></br>  
              </>
            */}     

              <Subtopics />
               <PushButton onClick={handleonNewQuestions} label={changeLanguage('aitest', 'generatequestions')} disablebutton={topic.length > 0 ? false : true} />
            </div>
          }

              
        </div>
       </div>

        <div ref={descriptionRef} >
          <Questions />
        </div>
        
      <ConnectedAccountDialog />
       <DialogTestLanguage requesttests={true}/>
       <DialogTestArea />
       <ConfirmDialog alertYes={confirmYes} openDialog = {openConfirmDialog} closeDialog = {closeConfirmDialogBox} prompt={dialogtext}/>
    </div>

  )
}




